import { render, staticRenderFns } from "./EditTickerLinkedBoards.vue?vue&type=template&id=6534427c&scoped=true&"
import script from "./EditTickerLinkedBoards.vue?vue&type=script&lang=js&"
export * from "./EditTickerLinkedBoards.vue?vue&type=script&lang=js&"
import style0 from "./EditTickerLinkedBoards.vue?vue&type=style&index=0&id=6534427c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534427c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VDialog,VIcon,VSpacer})
